

var article = `
## Obtener scroll

Es tan fácil como hacer:

> **var** scrollY **=** window **.** scrollY

O para obtener la posición del scroll en el **Eje X** hacer:

> **var** scrollX **=** window **.** scrollX

## Compartir scroll

Una forma es *pasarlo por url* como una **query** para poder *setearlo* cuando vuelva a la página anterior.

Por ejemplo:

> https:// pagina.com / blog / nombre-articulo **? scroll = 340**

Luego hay que extraer el valor de la query: **scroll = 340**, lo guardo con **localStorage** para tenerlo disponible cuando el usuario retroceda. 

> *//variable que contiene el valor de la query*\n**const** scrollY **=** scrollValueFromQuery

> *//almacenando el valor con el nombre "scrollY"*\nlocalStorage **.** setItem **(** "scrollY" **,** scrollY **)**

**NOTA:** para obtener el valor de la *query* ver [enlace de cómo extraer querys en JS]() (con librería o manualmente).

## Setear scroll

Cuando tenga el *valor del scroll* guardado en **localStorage**, se puede obtener desde cualquier lugar de la página. 

Similar a un [estado](https://es.reactjs.org/docs/hooks-state.html), o un elemento almacenado en [Redux](https://react-redux.js.org/).

Para obtenerlo, hacer:

> *//buscar el valor en localStorage con el nombre "scrollY"*\n**const** localStorageScrollY **=** localStorage **.** getItem **(** "scrollY" **)**

Ahora tengo el valor del **scroll** y ya puedo setearlo:

> *//indico cuanto tiene que deslizarse*\nwindow **.** scroll **(** 0 **,** localStorageScrollY **)**

**NOTA:** <code>window.scroll **(** EjeX **,** EjeY **)**</code> 

## Scroll con desplazamiento suave

Puede hacerse el movimiento suave del *scroll* con **CSS**, usando la propiedad:

> scroll-behavior **:** smooth **;**

Pero practicamente todos los navegadores traen desactivada esta propiedad por defecto.

### Librería scrolls.js

Con esta librería se puede conseguir el efecto del movimiento de scroll suave.

> npm install scrolls.js

Importar **scrolls**:

> **import** scrolls **from** "scrolls.js";

Setear el **scrollY**, me aseguro que sea un *número entero*:

> scrolls(*Number.parseInt(**scrollY**)*);

**FUENTE** y más configuraciones: https://scrollsjs.com/
`;


export default article